import {
    FETCH_SCHEMES_REQUEST,
    FETCH_SCHEMES_SUCCESS,
    FETCH_SCHEMES_FAILURE,
  } from "./FetchMedSchemesTypes";
  
  const initialState = {
    loading: false,
    schemes: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SCHEMES_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_SCHEMES_SUCCESS:
        return {
          loading: false,
          schemes: action.payload,
          error: "",
        };
      case FETCH_SCHEMES_FAILURE:
        return {
          loading: false,
          schemes: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  